import React from 'react';
import { Button, ButtonSize, ButtonType, ButtonVariant } from '@ids/react-button';

const SecondaryButton = ({ text, onClickEvent, isSmall = false }) => {
  return (
    <Button
      size={isSmall ? ButtonSize.SMALL : ButtonSize.MEDIUM}
      type={ButtonType.OUTLINED}
      variant={ButtonVariant.QUIET}
      onClick={onClickEvent}>
      {text}
    </Button>
  );
};

export default SecondaryButton;
